import {useCallback, useRef} from "react";

import {useElementWasVisible} from "@pg-mono/hooks";

interface Props {
    /** Only has to be unique among trackers mounted on the same page - used as the useElementWasVisible id. */
    id: string;
    onVisible: () => void;
}

const SECTION_HEADING_SELECTOR = "h1, h2, h3, h4, h5, h6";
const SECTION_VISIBILITY_THRESHOLD = 0.5;

/** A section taller than the viewport can never reach the visibility threshold, so the heading stands in for it. */
const getObservedElement = (sentinel: HTMLSpanElement | null): Element | null => {
    const section = sentinel?.parentElement ?? null;

    return section === null ? null : (section.querySelector(SECTION_HEADING_SELECTOR) ?? section);
};

/** Renders nothing visible - drop it inside a section to report that section as seen, once per page view. */
export const ViewSectionTracker = (props: Props) => {
    const {id, onVisible} = props;
    const observedElementRef = useRef<Element | null>(null);

    const setSentinelRef = useCallback((sentinel: HTMLSpanElement | null) => {
        observedElementRef.current = getObservedElement(sentinel);
    }, []);

    useElementWasVisible({
        ids: [],
        elementRefs: [{id, ref: observedElementRef}],
        onElementVisible: onVisible,
        once: true,
        threshold: SECTION_VISIBILITY_THRESHOLD
    });

    return <span ref={setSentinelRef} hidden aria-hidden="true" />;
};
import {useCallback, useRef} from "react";

import {useElementWasVisible} from "@pg-mono/hooks";

interface Props {
    /** Only has to be unique among trackers mounted on the same page - used as the useElementWasVisible id. */
    id: string;
    onVisible: () => void;
}

const SECTION_HEADING_SELECTOR = "h1, h2, h3, h4, h5, h6";
const SECTION_VISIBILITY_THRESHOLD = 0.5;

/** A section taller than the viewport can never reach the visibility threshold, so the heading stands in for it. */
const getObservedElement = (sentinel: HTMLSpanElement | null): Element | null => {
    const section = sentinel?.parentElement ?? null;

    return section === null ? null : (section.querySelector(SECTION_HEADING_SELECTOR) ?? section);
};

/** Renders nothing visible - drop it inside a section to report that section as seen, once per page view. */
export const ViewSectionTracker = (props: Props) => {
    const {id, onVisible} = props;
    const observedElementRef = useRef<Element | null>(null);

    const setSentinelRef = useCallback((sentinel: HTMLSpanElement | null) => {
        observedElementRef.current = getObservedElement(sentinel);
    }, []);

    useElementWasVisible({
        ids: [],
        elementRefs: [{id, ref: observedElementRef}],
        onElementVisible: onVisible,
        once: true,
        threshold: SECTION_VISIBILITY_THRESHOLD
    });

    return <span ref={setSentinelRef} hidden aria-hidden="true" />;
};
